import { IChildEditState } from 'main/components/child/ChildrenSelector'
import {
  IDesiredWeeklyScheduleParams,
  validateDesiredWeeklyScheduleParamsWithTranslation,
} from 'main/components/family/DesiredWeeklyScheduleFields'
import { IChild } from 'main/gql/child'
import { TFunction } from 'react-i18next'
import { i18nKeyPrefix } from '../../../i18n'
import { IValidation } from './types'

const PRE = `${i18nKeyPrefix}-VALIDATIONS`

export function initialChildEditStates(children: IChild[]) {
  if (!children.length) {
    return [{ childId: null }]
  }

  // A child is not considered selectable unless all of its information from the child form is
  // filled out. If a child is not selectable, it should be in an edit state upon initialization.
  return children.filter(child => !isChildSelectable(child)).map(child => ({ childId: child.id }))
}

export function isChildSelectable(child: IChild) {
  return (
    !!child.firstName &&
    !!child.lastName &&
    !!child.gender &&
    !!child.birthday &&
    !!child.desiredEnrollmentDate
  )
}

// If a child is selected but in an edit state, it is not considered actually selected, i.e. it
// would not be included in a tour confirmation submittion.
export function actualSelectedChildren(selectedChildren: IChild[], editStates: IChildEditState[]) {
  return selectedChildren.filter(
    child => !editStates.find(editState => editState.childId === child.id),
  )
}

export function validate(
  desiredWeeklyScheduleParams: IDesiredWeeklyScheduleParams,
  children: IChild[],
  selectedChildren: IChild[],
  childEditStates: IChildEditState[],
  t: TFunction,
) {
  const validation: IValidation = {}

  if (!actualSelectedChildren(selectedChildren, childEditStates).length) {
    if (children.length === 1) {
      const editState = childEditStates.find(e => e.childId === children[0].id)

      // Vary hint based on whether the only existing child is being edited
      validation.selectedChildren = editState ? t(`${PRE}-NOT-SAVED`) : t(`${PRE}-NOT-SELECTED`)
    } else if (children.length) {
      validation.selectedChildren = t(`${PRE}-NOT-SELECTED`)
    } else {
      validation.selectedChildren = t(`${PRE}-ADD-AT-LEAST`)
    }
  }

  const desiredWeeklyScheduleValidation = validateDesiredWeeklyScheduleParamsWithTranslation(
    desiredWeeklyScheduleParams,
    t,
  )
  if (desiredWeeklyScheduleValidation) {
    validation.desiredWeeklySchedule = desiredWeeklyScheduleValidation
  }

  return validation
}
